import { render, staticRenderFns } from "./toggle.vue?vue&type=template&id=4be5be83&scoped=true&"
import script from "./toggle.vue?vue&type=script&lang=js&"
export * from "./toggle.vue?vue&type=script&lang=js&"
import style0 from "./toggle.vue?vue&type=style&index=0&id=4be5be83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be5be83",
  null
  
)

export default component.exports